import { useState } from 'react'
import { BlockComponentFactory } from '../BlockFactory'
import { ContainerBlockProps } from './block-props.types'
import ChevronDown from '../../../assets/icons/chevron-down.svg?react'
import Flex from 'antd/lib/flex'
import { LABEL_BOLD_FONT_STYLE } from '../../constants'
import { LabelBlock } from './LabelBlock'
import { toCSSSize } from './block-utils'

export const ContainerBlock = BlockComponentFactory.createBlockComponent<ContainerBlockProps>(
    props => {
        const {
            label,
            collapsible = false,
            width,
            height,
            gap = 8,
            direction = 'vertical',
            visibility = 'visible',
            children,
        } = props

        const [isCollapsed, setIsCollapsed] = useState(false)

        const containerStyle: React.CSSProperties = {
            ...props.style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            padding: `12px`,
            backgroundColor: '#ffffff',
            borderRadius: `4px`,
            border: '1px solid #D8D8D8',
            width: toCSSSize(width) ?? 'auto',
            height: toCSSSize(height) ?? 'auto',
            overflow: 'auto',
            gap: '8px',
        }

        if (width) {
            containerStyle.flex = 'none'
        }

        const labelWrapperStyle: React.CSSProperties = {
            display: 'flex',
            alignItems: 'center',
            cursor: collapsible ? 'pointer' : 'default',
            userSelect: 'none',
        }

        const arrowStyle: React.CSSProperties = {
            transition: 'transform 0.2s ease',
            transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
        }

        const contentStyle: React.CSSProperties = {
            display: 'flex',
            flexDirection: direction === 'horizontal' ? 'row' : 'column',
            gap: `${gap}px`,
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
        }

        const handleToggle = () => {
            if (collapsible) {
                setIsCollapsed(!isCollapsed)
            }
        }

        return (
            <div style={containerStyle}>
                <Flex justify="space-between" style={labelWrapperStyle} onClick={handleToggle}>
                    <LabelBlock label={label} labelStyle={LABEL_BOLD_FONT_STYLE} />
                    {collapsible && (
                        <span style={arrowStyle}>
                            <ChevronDown />
                        </span>
                    )}
                </Flex>
                {(!collapsible || !isCollapsed) && <div style={contentStyle}>{children}</div>}
            </div>
        )
    }
)
